import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { SIDEBAR_STYLES } from "./sidebarConstants";

export const SidebarItem = ({
  collapsed,
  icon,
  text,
  link,
  badge,
  isMobile = false,
  exact = false,
  activePaths = [],
}) => {
  const location = useLocation();
  const matchesPath = (path) => (
    exact ? location.pathname === path : location.pathname === path || location.pathname.startsWith(`${path}/`)
  );

  const isActive = activePaths.length > 0
    ? activePaths.some((path) => matchesPath(path))
    : link === "/home"
      ? location.pathname === link
      : matchesPath(link);

  return (
    <NavLink
      to={link}
      className={`group relative my-1 flex items-center rounded-lg px-3 py-3 text-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
        collapsed && !isMobile ? "justify-center" : "gap-3"
      }`}
      style={{
        backgroundColor: isActive ? SIDEBAR_STYLES.ACTIVE_BG : "transparent",
        color: isActive ? SIDEBAR_STYLES.ACTIVE_COLOR : SIDEBAR_STYLES.TEXT_COLOR,
      }}
    >
      {isActive ? <div className="absolute left-0 top-1/2 h-6 w-1 -translate-y-1/2 rounded-r-full bg-blue-600" /> : null}
      <div className={`flex-shrink-0 ${isActive ? "text-blue-600" : "text-gray-600"}`}>{icon}</div>
      {collapsed && !isMobile ? null : (
        <div className="flex min-w-0 flex-1 items-center gap-2">
          <span className={`truncate font-ui font-medium ${isActive ? "text-blue-600" : "text-gray-700"}`}>{text}</span>
          {badge ? <span className="rounded-full bg-orange-500 px-1.5 py-0.5 text-[0.625rem] text-white">{badge}</span> : null}
        </div>
      )}

      {collapsed && !isMobile ? (
        <div className="pointer-events-none absolute left-full top-1/2 z-50 ml-2 -translate-y-1/2 whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs text-white opacity-0 transition-opacity duration-200 group-hover:opacity-100">
          {text}
          {badge ? ` (${badge})` : ""}
          <div className="absolute right-full top-1/2 -translate-y-1/2 border-4 border-transparent border-r-gray-900" />
        </div>
      ) : null}
    </NavLink>
  );
};
